import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Button, Teaser } from '../ui'

export type CtaProps = {
  title?: string
  buttonLabel?: string
  type?: 'firm' | 'offer'
}

const Cta: React.FC<CtaProps> = ({
  title = 'Aucun résultat ne vous correspond ? Déposez votre CV !',
  buttonLabel = 'Déposer mon CV',
  type = 'firm',
}) => (
  <Teaser
    header={
      <StaticImage
        src="../../../static/cta-header-media.jpg"
        alt="header lamacompta"
        placeholder="blurred"
        formats={['webp']}
        layout="constrained"
        className="object-cover w-full h-full"
      />
    }
    logo={<img src="../../Logo_V_Lamacompta.jpg" alt="Logo Lamacompta" />}
    url="https://lamadash.fr/signup_login_candidat"
    type={type}
  >
    <div className="flex flex-row mt-2">
      <div className="m-2 font-semibold text-md lg:text-start grow">
        {title}
      </div>
    </div>
    <div className="hidden lg:block">
      <Button size="small" label={buttonLabel} invert color="primary" />
    </div>
  </Teaser>
)

export default Cta
